import React, {DetailedHTMLProps, HTMLAttributes} from "react";
import {dispatchRedirectTo} from "../../../ts/event/DispatchEvent";

const HTMLContentView = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) =>
{
    const contentClickHandler = (event:React.MouseEvent<HTMLDivElement>) => {

        if(props.onClick){
            props.onClick(event);
        }
        if(event.target instanceof HTMLAnchorElement){

            let href = event.target.href;
            if(href.startsWith(window.location.origin)){
                href = href.substring(window.location.origin.length)
            }
            let target = event.target.target;
            target = target ? target : "_self"
            if(href.startsWith("/")){
                if(props.onClick){
                    props.onClick(event);
                }
                dispatchRedirectTo(href, true);
                event.preventDefault();
            } else if((target === "_self") && (href.startsWith("http://") || href.startsWith("https://"))){
                if(props.onClick){
                    props.onClick(event);
                }
                window.open(href, '_blank')?.focus();
                event.preventDefault();
            }
        }
    };

    return <div
        {...props}
        onClick={contentClickHandler}
    ></div>
}
export default HTMLContentView;